import { render, staticRenderFns } from "./DepositExternalInfoBox.vue?vue&type=template&id=162d93d8"
import script from "./DepositExternalInfoBox.vue?vue&type=script&lang=js"
export * from "./DepositExternalInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports